(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoicesGpfsController', InvoicesGpfsController);

    InvoicesGpfsController.$inject = ['$scope', 'category', 'InvoiceCustomService', 'GpfsBatch', 'GpfsBatchCustomService', '$uibModal', 'ToastrService'];

    function InvoicesGpfsController ($scope, category, InvoiceCustomService, GpfsBatch, GpfsBatchCustomService, $uibModal, ToastrService) {
        var vm = this;
        vm.category = category;
        vm.invoicesList = [];
        vm.batchesList = [];
        vm.checkedAll = false;

        vm.sortType = "invDate";
        vm.sortReverse = false;

        vm.loadAll = loadAll;
        vm.downloadCSV = downloadCSV;
        vm.revertBatch = revertBatch;

        loadAll();

        function loadAll() {
            if (vm.category.action === 'CREATE') {
                vm.invoicesList = [];
                InvoiceCustomService.returnInvoicesGpfs().then(function (result) {
                    vm.invoicesList = result.data;
                    for (var i = 0; i < vm.invoicesList.length; i++) {
                        vm.invoicesList.exclude = false;
                    }
                    vm.checkedAll = false;
                }, function () {
                    vm.invoicesList = [];
                });
            } else if (vm.category.action === 'REVERT') {
                vm.batchesList = [];
                var predicate = 'batchDate';
                var order = 'desc';
                var sort = [predicate + ',' + order];
                var queryParams = {
                    size: 100,
                    sort: sort
                };
                GpfsBatch.query(queryParams, function (result) {
                    vm.batchesList = result;
                }, function () {
                    vm.batchesList = [];
                });
            }
        }

        function downloadCSV(type) {
            var excluded = [];
            var index = 0;
            for (var i = 0; i < vm.invoicesList.length; i++) {
                if (vm.invoicesList[i].exclude === true) {
                    excluded[index] = vm.invoicesList[i].id;
                    index++;
                }
            }
            var today = new Date();
            var year = today.getFullYear();
            var day = today.getDate();
            var month = today.getMonth() + 1;
            InvoiceCustomService.returnInvoicesGpfsDownload(type, excluded).then(function(result) {
                today = "-" + year + "-" + day + "-" + month;
                var filename = "int-file.txt";
                switch (type) {
                    case 'PURCHASE': filename = "SBFAPInt.txt"; break;
                    case 'SALE': filename = "SBFARInt.txt"; break;
                    case 'JAPAN': filename = "SBFJPInt.txt"; break;
                }
                if (window.navigator.msSaveOrOpenBlob) {
                    var blob = new Blob([decodeURIComponent(encodeURI(result.data))], {
                        type: "text/plain;charset=utf-8;"
                    });
                    navigator.msSaveBlob(blob, filename);
                } else {
                    var a = document.createElement('a');
                    a.href = 'data:attachment/text;charset=utf-8,' + encodeURI(result.data);
                    a.target = '_blank';
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
                ToastrService.success("CSV file has been generated");
                vm.loadAll();
            }, function (error) {
                ToastrService.error("Error occured while generation CSV file to download");
                vm.loadAll();
            });
        }

        function revertBatch(batch) {
            $uibModal.open({
                templateUrl: 'app/entities/invoice/invoices-gpfs-dialog.html',
                controller: 'InvoiceGpfsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            batchId: batch.id,
                            batch: batch.batch,
                            type: batch.gpfsType
                        }
                    }
                }
            }).result.then(function (val) {
                ToastrService.success("Reverted all Invoices included on Batch " + batch.batch );
                loadAll();
            }, function (error) {
                loadAll();
            });
        }

        $scope.$watch('vm.checkedAll', function (newValue, oldValue) {
            for (var i = 0; i < vm.invoicesList.length; i++) {
                vm.invoicesList[i].exclude = angular.copy(newValue);
            }
        });
    }
})();
